import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ValidUserGuard} from "./@core/valid-user.guard";
import {SignonComponent} from './main/signon.component';
import {UnAuthComponent} from "./main/un-auth.component";
import {ApplResultComponent} from "./application/appl-result/appl-result.component";
import {ApplFormComponent} from "./application/appl-form/appl-form.component";
import {LayoutComponent} from './main/layout.component';
import {PanelComponent} from './application/panel.component';
import {ValidAppGuard} from "./@core/valid-app-guard.service";

const routes: Routes = [
  {
    path: '',
    component: SignonComponent,
  },
  {
    path: 'sso/:token',
    component: SignonComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [ValidUserGuard],
    canActivateChild: [ValidUserGuard],
    children: [
      {
        path: 'apply',
        component: PanelComponent,
      },
      {
        path: '',
        canActivate: [ValidAppGuard],
        children: [
          {
            path: 'form',
            component: ApplFormComponent,
          },
          {
            path: 'summary',
            component: ApplFormComponent,
          },
          {
            path: 'result',
            component: ApplResultComponent,
          }
        ]
      },
    ]
  },
  {
    path: 'unauth', component: UnAuthComponent,
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
